/**
 * Dev-Only Console Guard
 * Silences all console output outside of development builds so that
 * logs (including any sensitive data) are only ever emitted in dev.
 *
 * Must be imported BEFORE any other module in the application entry point
 * so that console calls made at module load time are also suppressed.
 */
const isDev = process.env.NODE_ENV === 'development'

if (!isDev) {
  const noop = () => {}
  // eslint-disable-next-line no-console
  ;['log', 'debug', 'info', 'warn', 'error'].forEach((method) => {
    // eslint-disable-next-line no-console
    if (typeof console[method] === 'function') {
      // eslint-disable-next-line no-console
      console[method] = noop
    }
  })
}

export default null
